export function createAmazonUrl(internalId, lines = null) {
  const amazonApplicationId =
    'amzn1.sp.solution.74434333-27df-40b9-8ceb-722a7c23980c';
  const versionBeta = '&version=beta';
  const lineIds = !lines ? '' : `_${JSON.stringify(lines)}`;
  const amazonUrl = `https://sellercentral.amazon.com/apps/authorize/consent?application_id=${amazonApplicationId}&redirect_uri=https://${window.location.hostname}/amazon-seller-redirect&state=${internalId}_${window.location.pathname}${lineIds}${versionBeta}`;
  return amazonUrl;
}
